import React, { useEffect, useState } from 'react'
import OutwaredBinReportTable from '../../Comman/OutwaredBinReportTable'

const DS_OutwaredBin = () => {


    return (
        <>
            <OutwaredBinReportTable location={"dispatch_center"}/>
        </>
    )
}

export default DS_OutwaredBin